import { render, staticRenderFns } from "./base-tree.vue?vue&type=template&id=157f6c2c&scoped=true"
import script from "./base-tree.vue?vue&type=script&lang=js"
export * from "./base-tree.vue?vue&type=script&lang=js"
import style0 from "./base-tree.vue?vue&type=style&index=0&id=157f6c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157f6c2c",
  null
  
)

export default component.exports